import { CheckCircle2 } from 'lucide-react'
import {
  ADD_ON_PRICE_NOTE,
  protectionAddOns,
  type AddOnSelection,
} from '../../data/protection-addons'
import { Button } from '../ui/button'

export interface AddOnChoiceListProps {
  selection: AddOnSelection
  onToggle: (id: string) => void
}

export function AddOnChoiceList({
  selection,
  onToggle,
}: Readonly<AddOnChoiceListProps>) {
  return (
    <div className="addon-choice-list">
      {protectionAddOns.map((item) => {
        const selected = selection.addOnIds.includes(item.id)
        return (
          <article
            aria-current={selected ? 'true' : undefined}
            className={selected ? 'addon-choice-card is-selected' : 'addon-choice-card'}
            key={item.id}
          >
            <div>
              <h3>{item.name}</h3>
              <p>{item.description}</p>
              {item.surfaces ? (
                <ul>
                  {item.surfaces.map((surface) => (
                    <li key={surface}>{surface}</li>
                  ))}
                </ul>
              ) : null}
              <p className="addon-price-note">{ADD_ON_PRICE_NOTE}</p>
            </div>
            <Button
              aria-pressed={selected}
              onClick={() => onToggle(item.id)}
              type="button"
              variant={selected ? 'solid' : 'ghost'}
            >
              {selected ? (
                <>
                  <CheckCircle2 aria-hidden="true" size={16} /> Selected
                </>
              ) : (
                `Add ${item.shortName}`
              )}
            </Button>
          </article>
        )
      })}
    </div>
  )
}
